import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InfoModalService {
  readonly visible = signal(false);
  readonly title = signal('Information');
  readonly message = signal('');

  open(title: string, message: string): void {
    this.title.set(title);
    this.message.set(message);
    this.visible.set(true);
  }

  close(): void {
    this.visible.set(false);
  }
}
